import type { TStoreName } from "../types/domain/store";
import { buildDocument } from "./build-document";
import { APP_NAME } from "./store";

export const metaobjectQuery = buildDocument(`#graphql
  query Metaobjects($type: String!, $first: Int) {
    metaobjects(type: $type, first: $first) {
      edges {
        node {
          handle
          id
          fields {
            ...MetaobjectFieldFields
          }
        }
      }
    }
  }
`);

/** 미디어 참조를 포함한 메타오브젝트 목록 */
export const mediaMetaobjectQuery = buildDocument(`#graphql
  query MediaMetaobjects($type: String!, $first: Int, $reverse: Boolean, $sortKey: String) {
    metaobjects(type: $type, first: $first, reverse: $reverse, sortKey: $sortKey) {
      edges {
        node {
          handle
          id
          updatedAt
          fields {
            ...MetaobjectFieldFields
            references(first: 100) {
              edges {
                node {
                  ...MediaImageFields
                }
              }
            }
            reference {
              ...MediaImageFields
            }
          }
        }
      }
    }
  }
`);

/** 검색 추천어 메타오브젝트 (스토어별 field key가 다름) */
const SEARCH_METAOBJECT_OPS: Record<TStoreName, string> = {
  tune: `#graphql
    query MetaobjectsSearchTune($type: String!, $first: Int, $reverse: Boolean) {
      metaobjects(type: $type, first: $first, reverse: $reverse) {
        edges {
          node {
            handle
            value: field(key: "value") {
              value
              type
            }
          }
        }
      }
    }
  `,
  yeseyesee: `#graphql
    query MetaobjectsSearchYeseyesee($type: String!, $first: Int, $reverse: Boolean) {
      metaobjects(type: $type, first: $first, reverse: $reverse) {
        edges {
          node {
            handle
            value: field(key: "values") {
              value
              type
            }
          }
        }
      }
    }
  `,
  thisisneverthat: `#graphql
    query MetaobjectsSearchThisisneverthat($type: String!, $first: Int, $reverse: Boolean) {
      metaobjects(type: $type, first: $first, reverse: $reverse) {
        edges {
          node {
            handle
            value: field(key: "values") {
              value
              type
            }
          }
        }
      }
    }
  `,
  khakis: `#graphql
    query MetaobjectsSearchKhakis($type: String!, $first: Int, $reverse: Boolean) {
      metaobjects(type: $type, first: $first, reverse: $reverse) {
        edges {
          node {
            handle
            value: field(key: "values") {
              value
              type
            }
          }
        }
      }
    }
  `,
  sunlove: `#graphql
    query MetaobjectsSearchSunlove($type: String!, $first: Int, $reverse: Boolean) {
      metaobjects(type: $type, first: $first, reverse: $reverse) {
        edges {
          node {
            handle
            value: field(key: "values") {
              value
              type
            }
          }
        }
      }
    }
  `,
  wellbeingexpress: `#graphql
    query MetaobjectsSearchWellbeingexpress($type: String!, $first: Int, $reverse: Boolean) {
      metaobjects(type: $type, first: $first, reverse: $reverse) {
        edges {
          node {
            handle
            value: field(key: "values") {
              value
              type
            }
          }
        }
      }
    }
  `,
  tenui: `#graphql
    query MetaobjectsSearchTenui($type: String!, $first: Int, $reverse: Boolean) {
      metaobjects(type: $type, first: $first, reverse: $reverse) {
        edges {
          node {
            handle
            value: field(key: "value") {
              value
              type
            }
          }
        }
      }
    }
  `,
};

export const searchMetaobjectQuery = buildDocument(SEARCH_METAOBJECT_OPS[APP_NAME]);

/** 랭킹 메타오브젝트 (아카이브세일 TRENDING) */
const RANKING_METAOBJECT_OPS: Record<TStoreName, string> = {
  tune: `#graphql
    query RankingMetaobjectsTune($type: String!, $first: Int, $reverse: Boolean) {
      metaobjects(type: $type, first: $first, reverse: $reverse) {
        edges {
          node {
            handle
            id
            updatedAt
            ...MetaobjectProductRefFieldsTune
          }
        }
      }
    }
  `,
  yeseyesee: `#graphql
    query RankingMetaobjectsYeseyesee($type: String!, $first: Int, $reverse: Boolean) {
      metaobjects(type: $type, first: $first, reverse: $reverse) {
        edges {
          node {
            handle
            id
            updatedAt
            ...MetaobjectProductRefFieldsYeseyesee
          }
        }
      }
    }
  `,
  thisisneverthat: `#graphql
    query RankingMetaobjectsThisisneverthat($type: String!, $first: Int, $reverse: Boolean) {
      metaobjects(type: $type, first: $first, reverse: $reverse) {
        edges {
          node {
            handle
            id
            updatedAt
            ...MetaobjectProductRefFieldsThisisneverthat
          }
        }
      }
    }
  `,
  khakis: `#graphql
    query RankingMetaobjectsKhakis($type: String!, $first: Int, $reverse: Boolean) {
      metaobjects(type: $type, first: $first, reverse: $reverse) {
        edges {
          node {
            handle
            id
            updatedAt
            ...MetaobjectProductRefFieldsKhakis
          }
        }
      }
    }
  `,
  sunlove: `#graphql
    query RankingMetaobjectsSunlove($type: String!, $first: Int, $reverse: Boolean) {
      metaobjects(type: $type, first: $first, reverse: $reverse) {
        edges {
          node {
            handle
            id
            updatedAt
            ...MetaobjectProductRefFieldsSunlove
          }
        }
      }
    }
  `,
  wellbeingexpress: `#graphql
    query RankingMetaobjectsWellbeingexpress($type: String!, $first: Int, $reverse: Boolean) {
      metaobjects(type: $type, first: $first, reverse: $reverse) {
        edges {
          node {
            handle
            id
            updatedAt
            ...MetaobjectProductRefFieldsWellbeingexpress
          }
        }
      }
    }
  `,
  tenui: `#graphql
    query RankingMetaobjectsTenui($type: String!, $first: Int, $reverse: Boolean) {
      metaobjects(type: $type, first: $first, reverse: $reverse) {
        edges {
          node {
            handle
            id
            updatedAt
            ...MetaobjectProductRefFieldsTenui
          }
        }
      }
    }
  `,
};

export const rankingMetaobjectQuery = buildDocument(RANKING_METAOBJECT_OPS[APP_NAME]);

/** handle로 메타오브젝트 단건 조회 */
const METAOBJECT_BY_HANDLE_OPS: Record<TStoreName, string> = {
  tune: `#graphql
    query MetaobjectByHandleTune($handle: MetaobjectHandleInput!) {
      metaobject(handle: $handle) {
        handle
        id
        updatedAt
        fields {
          ...MetaobjectFieldFields
          references(first: 100) {
            edges { node { ...MediaImageFields ...CollectionSummaryFields ...MetaobjectDetailFieldsTune } }
          }
          reference { ...MediaImageFields ...MetaobjectDetailFieldsTune }
        }
      }
    }
  `,
  yeseyesee: `#graphql
    query MetaobjectByHandleYeseyesee($handle: MetaobjectHandleInput!) {
      metaobject(handle: $handle) {
        handle
        id
        updatedAt
        fields {
          ...MetaobjectFieldFields
          references(first: 100) {
            edges { node { ...MediaImageFields ...CollectionSummaryFields ...MetaobjectDetailFields } }
          }
          reference { ...MediaImageFields ...MetaobjectDetailFields }
        }
      }
    }
  `,
  thisisneverthat: `#graphql
    query MetaobjectByHandleThisisneverthat($handle: MetaobjectHandleInput!) {
      metaobject(handle: $handle) {
        handle
        id
        updatedAt
        fields {
          ...MetaobjectFieldFields
          references(first: 100) {
            edges { node { ...MediaImageFields ...CollectionSummaryFields ...MetaobjectDetailFields } }
          }
          reference { ...MediaImageFields ...MetaobjectDetailFields }
        }
      }
    }
  `,
  khakis: `#graphql
    query MetaobjectByHandleKhakis($handle: MetaobjectHandleInput!) {
      metaobject(handle: $handle) {
        handle
        id
        updatedAt
        fields {
          ...MetaobjectFieldFields
          references(first: 100) {
            edges { node { ...MediaImageFields ...CollectionSummaryFields ...MetaobjectDetailFields } }
          }
          reference { ...MediaImageFields ...MetaobjectDetailFields }
        }
      }
    }
  `,
  sunlove: `#graphql
    query MetaobjectByHandleSunlove($handle: MetaobjectHandleInput!) {
      metaobject(handle: $handle) {
        handle
        id
        updatedAt
        fields {
          ...MetaobjectFieldFields
          references(first: 100) {
            edges { node { ...MediaImageFields ...CollectionSummaryFields ...MetaobjectDetailFields } }
          }
          reference { ...MediaImageFields ...MetaobjectDetailFields }
        }
      }
    }
  `,
  wellbeingexpress: `#graphql
    query MetaobjectByHandleWellbeingexpress($handle: MetaobjectHandleInput!) {
      metaobject(handle: $handle) {
        handle
        id
        updatedAt
        fields {
          ...MetaobjectFieldFields
          references(first: 100) {
            edges { node { ...MediaImageFields ...CollectionSummaryFields ...MetaobjectDetailFieldsWellbeingexpress } }
          }
          reference { ...MediaImageFields ...MetaobjectDetailFieldsWellbeingexpress }
        }
      }
    }
  `,
  tenui: `#graphql
    query MetaobjectByHandleTenui($handle: MetaobjectHandleInput!) {
      metaobject(handle: $handle) {
        handle
        id
        updatedAt
        fields {
          ...MetaobjectFieldFields
          references(first: 100) {
            edges { node { ...MediaImageFields ...CollectionSummaryFields ...MetaobjectDetailFieldsTenui } }
          }
          reference { ...MediaImageFields ...MetaobjectDetailFieldsTenui }
        }
      }
    }
  `,
};

export const metaobjectByHandleQuery = buildDocument(METAOBJECT_BY_HANDLE_OPS[APP_NAME]);

/** 인덱스(홈) 메타오브젝트 조회 */
const INDEX_METAOBJECT_OPS: Record<TStoreName, string> = {
  tune: `#graphql
    query IndexMetaobjectsTune($type: String!, $first: Int, $reverse: Boolean) {
      metaobjects(type: $type, first: $first, reverse: $reverse) {
        edges { node {
          handle
          id
          updatedAt
          fields {
            ...MetaobjectFieldFields
            references(first: 48) {
              edges { node { ...ProductFieldsTune ...MediaImageFields ...MetaobjectImageProductFieldsTune } }
            }
            reference { ...MetaobjectImageProductFieldsTune ...MediaImageFields }
          }
        } }
      }
    }
  `,
  yeseyesee: `#graphql
    query IndexMetaobjectsYeseyesee($type: String!, $first: Int, $reverse: Boolean) {
      metaobjects(type: $type, first: $first, reverse: $reverse) {
        edges { node {
          handle
          id
          updatedAt
          fields {
            ...MetaobjectFieldFields
            references(first: 48) {
              edges { node { ...ProductCommonFields ...MediaImageFields ...MetaobjectImageProductFieldsYeseyesee } }
            }
            reference { ...MetaobjectImageProductFieldsYeseyesee ...MediaImageFields }
          }
        } }
      }
    }
  `,
  thisisneverthat: `#graphql
    query IndexMetaobjectsThisisneverthat($type: String!, $first: Int, $reverse: Boolean) {
      metaobjects(type: $type, first: $first, reverse: $reverse) {
        edges { node {
          handle
          id
          updatedAt
          fields {
            ...MetaobjectFieldFields
            references(first: 48) {
              edges { node { ...ProductCommonFields ...MediaImageFields ...MetaobjectImageProductFieldsThisisneverthat } }
            }
            reference { ...MetaobjectImageProductFieldsThisisneverthat ...MediaImageFields }
          }
        } }
      }
    }
  `,
  khakis: `#graphql
    query IndexMetaobjectsKhakis($type: String!, $first: Int, $reverse: Boolean) {
      metaobjects(type: $type, first: $first, reverse: $reverse) {
        edges { node {
          handle
          id
          updatedAt
          fields {
            ...MetaobjectFieldFields
            references(first: 48) {
              edges { node { ...ProductCommonFields ...MediaImageFields ...MetaobjectImageProductFieldsKhakis } }
            }
            reference { ...MetaobjectImageProductFieldsKhakis ...MediaImageFields }
          }
        } }
      }
    }
  `,
  sunlove: `#graphql
    query IndexMetaobjectsSunlove($type: String!, $first: Int, $reverse: Boolean) {
      metaobjects(type: $type, first: $first, reverse: $reverse) {
        edges { node {
          handle
          id
          updatedAt
          fields {
            ...MetaobjectFieldFields
            references(first: 48) {
              edges { node { ...ProductCommonFields ...MediaImageFields ...MetaobjectImageProductFieldsSunlove } }
            }
            reference { ...MetaobjectImageProductFieldsSunlove ...MediaImageFields }
          }
        } }
      }
    }
  `,
  wellbeingexpress: `#graphql
    query IndexMetaobjectsWellbeingexpress($type: String!, $first: Int, $reverse: Boolean) {
      metaobjects(type: $type, first: $first, reverse: $reverse) {
        edges { node {
          handle
          id
          updatedAt
          fields {
            ...MetaobjectFieldFields
            references(first: 48) {
              edges { node { ...ProductFieldsWellbeingexpress ...MediaImageFields ...MetaobjectImageProductFieldsWellbeingexpress } }
            }
            reference { ...MetaobjectImageProductFieldsWellbeingexpress ...MediaImageFields }
          }
        } }
      }
    }
  `,
  // tenui 홈(home_layout)은 section_list > banner_items 로 메타오브젝트가 2단 중첩된다.
  tenui: `#graphql
    query IndexMetaobjectsTenui($type: String!, $first: Int, $reverse: Boolean) {
      metaobjects(type: $type, first: $first, reverse: $reverse) {
        edges { node {
          handle
          id
          updatedAt
          fields {
            ...MetaobjectFieldFields
            references(first: 50) {
              edges { node { __typename ...MediaImageFields ...MetaobjectImageProductFieldsTenui } }
            }
            reference { __typename ...MediaImageFields ...MetaobjectImageProductFieldsTenui }
          }
        } }
      }
    }
  `,
};

export const indexMetaobjectQuery = buildDocument(INDEX_METAOBJECT_OPS[APP_NAME]);

/** type으로 메타오브젝트 조회 */
const METAOBJECTS_BY_TYPE_OPS: Record<TStoreName, string> = {
  tune: `#graphql
    query MetaobjectsByTypeTune($type: String!, $first: Int, $reverse: Boolean) {
      metaobjects(type: $type, first: $first, reverse: $reverse) {
        edges { node {
          __typename
          id
          handle
          fields {
            ...MetaobjectFieldFields
            references(first: 12) {
              edges { node {
                ... on Product {
                  ...ProductFieldsTune
                  variants(first: 10) {
            edges {
              node {
                ...VariantBaseFields
                product { handle }
              }
            }
          }
                }
                ... on MediaImage { id ...MediaImageFields }
                ...MetaobjectDetailFieldsTune
                ...VideoFields
              } }
            }
            reference {
              ...MediaImageFields
              ...VideoFields
              ...CollectionSummaryFields
              ...VariantBaseFields
              ...MetaobjectImageProductFieldsTune
              ... on Product {
                ...ProductFieldsTune
                variants(first: 40) {
            edges {
              node {
                ...VariantBaseFields
                product { handle }
              }
            }
          }
              }
            }
          }
        } }
      }
    }
  `,
  yeseyesee: `#graphql
    query MetaobjectsByTypeYeseyesee($type: String!, $first: Int, $reverse: Boolean) {
      metaobjects(type: $type, first: $first, reverse: $reverse) {
        edges { node {
          id
          handle
          fields {
            ...MetaobjectFieldFields
            references(first: 12) {
              edges { node {
                ... on Product {
                  ...ProductCommonFields
                  variants(first: 10) {
            edges {
              node {
                ...VariantBaseFields
                product { handle }
              }
            }
          }
                }
                ... on MediaImage { id ...MediaImageFields }
                ...MetaobjectDetailFields
                ...VideoFields
              } }
            }
            reference {
              ...MediaImageFields
              ...VideoFields
              ...CollectionSummaryFields
              ...VariantBaseFields
              ...MetaobjectImageProductFieldsYeseyesee
              ... on Product {
                ...ProductCommonFields
                variants(first: 40) {
            edges {
              node {
                ...VariantBaseFields
                product { handle }
              }
            }
          }
              }
            }
          }
        } }
      }
    }
  `,
  thisisneverthat: `#graphql
    query MetaobjectsByTypeThisisneverthat($type: String!, $first: Int, $reverse: Boolean) {
      metaobjects(type: $type, first: $first, reverse: $reverse) {
        edges { node {
          id
          handle
          fields {
            ...MetaobjectFieldFields
            references(first: 12) {
              edges { node {
                ... on Product {
                  ...ProductCommonFields
                  variants(first: 10) {
            edges {
              node {
                ...VariantBaseFields
                product { handle }
              }
            }
          }
                }
                ... on MediaImage { id ...MediaImageFields }
                ...MetaobjectDetailFields
                ...VideoFields
              } }
            }
            reference {
              ...MediaImageFields
              ...VideoFields
              ...CollectionSummaryFields
              ...VariantBaseFields
              ...MetaobjectImageProductFieldsThisisneverthat
              ... on Product {
                ...ProductCommonFields
                variants(first: 40) {
            edges {
              node {
                ...VariantBaseFields
                product { handle }
              }
            }
          }
              }
            }
          }
        } }
      }
    }
  `,
  khakis: `#graphql
    query MetaobjectsByTypeKhakis($type: String!, $first: Int, $reverse: Boolean) {
      metaobjects(type: $type, first: $first, reverse: $reverse) {
        edges { node {
          id
          handle
          fields {
            ...MetaobjectFieldFields
            references(first: 12) {
              edges { node {
                ... on Product {
                  ...ProductCommonFields
                  variants(first: 10) {
            edges {
              node {
                ...VariantBaseFields
                  ...VariantMetafieldsKhakis
                product { handle }
              }
            }
          }
                }
                ... on MediaImage { id ...MediaImageFields }
                ...MetaobjectDetailFields
                ...VideoFields
              } }
            }
            reference {
              ...MediaImageFields
              ...VideoFields
              ...CollectionSummaryFields
              ...VariantBaseFields
              ...MetaobjectImageProductFieldsKhakis
              ... on Product {
                ...ProductCommonFields
                variants(first: 40) {
            edges {
              node {
                ...VariantBaseFields
                  ...VariantMetafieldsKhakis
                product { handle }
              }
            }
          }
              }
            }
          }
        } }
      }
    }
  `,
  sunlove: `#graphql
    query MetaobjectsByTypeSunlove($type: String!, $first: Int, $reverse: Boolean) {
      metaobjects(type: $type, first: $first, reverse: $reverse) {
        edges { node {
          id
          handle
          fields {
            ...MetaobjectFieldFields
            references(first: 12) {
              edges { node {
                ... on Product {
                  ...ProductCommonFields
                  variants(first: 10) {
            edges {
              node {
                ...VariantBaseFields
                product { handle }
              }
            }
          }
                }
                ... on MediaImage { id ...MediaImageFields }
                ...MetaobjectDetailFields
                ...VideoFields
              } }
            }
            reference {
              ...MediaImageFields
              ...VideoFields
              ...CollectionSummaryFields
              ...VariantBaseFields
              ...MetaobjectImageProductFieldsSunlove
              ... on Product {
                ...ProductCommonFields
                variants(first: 40) {
            edges {
              node {
                ...VariantBaseFields
                product { handle }
              }
            }
          }
              }
            }
          }
        } }
      }
    }
  `,
  wellbeingexpress: `#graphql
    query MetaobjectsByTypeWellbeingexpress($type: String!, $first: Int, $reverse: Boolean) {
      metaobjects(type: $type, first: $first, reverse: $reverse) {
        edges { node {
          id
          handle
          fields {
            ...MetaobjectFieldFields
            references(first: 12) {
              edges { node {
                ... on Product {
                  ...ProductFieldsWellbeingexpress
                  variants(first: 10) {
            edges {
              node {
                ...VariantBaseFields
                product { handle }
              }
            }
          }
                }
                ... on MediaImage { id ...MediaImageFields }
                ...MetaobjectDetailFieldsWellbeingexpress
                ...VideoFields
              } }
            }
            reference {
              ...MediaImageFields
              ...VideoFields
              ...CollectionSummaryFields
              ...VariantBaseFields
              ...MetaobjectImageProductFieldsWellbeingexpress
              ... on Product {
                ...ProductFieldsWellbeingexpress
                variants(first: 40) {
            edges {
              node {
                ...VariantBaseFields
                product { handle }
              }
            }
          }
              }
            }
          }
        } }
      }
    }
  `,
  tenui: `#graphql
    query MetaobjectsByTypeTenui($type: String!, $first: Int, $reverse: Boolean) {
      metaobjects(type: $type, first: $first, reverse: $reverse) {
        edges { node {
          id
          handle
          type
          fields {
            ...MetaobjectFieldFields
            references(first: 20) {
              edges { node {
                __typename
                ...MediaImageFields
                ...VideoFields
                ...MetaobjectDetailFieldsTenui
                ... on Product {
                  ...ProductCommonFields
                  variants(first: 10) {
                    edges { node { ...VariantBaseFields product { handle } } }
                  }
                }
              } }
            }
            reference {
              __typename
              ...MediaImageFields
              ...VideoFields
              ...CollectionSummaryFields
              ...MetaobjectImageProductFieldsTenui
              ... on Product {
                ...ProductCommonFields
                capacity: metafield(namespace: "info", key: "capacity") { ...MetafieldFields }
                cardTag: metafield(namespace: "info", key: "card_tag") { ...MetafieldFields }
                cardDescription: metafield(namespace: "info", key: "card_description") { ...MetafieldFields }
                hoverImage: metafield(namespace: "info", key: "hover_image") {
                  ...MetafieldFields
                  reference { __typename ...MediaImageFields }
                }
              }
            }
          }
        } }
      }
    }
  `,
};

export const metaobjectTypeQuery = buildDocument(METAOBJECTS_BY_TYPE_OPS[APP_NAME]);

/** 이미지 메타오브젝트 조회 */
const METAOBJECT_IMAGE_OPS: Record<TStoreName, string> = {
  tune: `#graphql
    query MetaobjectImageTune($type: String!, $first: Int, $reverse: Boolean) {
      metaobjects(type: $type, first: $first, reverse: $reverse) {
        edges { node {
          handle
          id
          updatedAt
          fields {
            ...MetaobjectFieldFields
            references(first: 100) {
              edges { node {
                ... on Metaobject {
                  id
                  fields {
                    key
                    value
                    type
                    references(first: 100) { edges { node { ...MetaobjectDetailFieldsTune } } }
                  }
                }
              } }
            }
            reference { ...MediaImageFields ...MetaobjectDetailFieldsTune }
          }
        } }
      }
    }
  `,
  yeseyesee: `#graphql
    query MetaobjectImageYeseyesee($type: String!, $first: Int, $reverse: Boolean) {
      metaobjects(type: $type, first: $first, reverse: $reverse) {
        edges { node {
          handle
          id
          updatedAt
          fields {
            ...MetaobjectFieldFields
            references(first: 100) {
              edges { node {
                ... on Metaobject {
                  id
                  fields {
                    key
                    value
                    type
                    references(first: 100) { edges { node { ...MetaobjectDetailFields } } }
                  }
                }
              } }
            }
            reference { ...MediaImageFields ...MetaobjectDetailFields }
          }
        } }
      }
    }
  `,
  thisisneverthat: `#graphql
    query MetaobjectImageThisisneverthat($type: String!, $first: Int, $reverse: Boolean) {
      metaobjects(type: $type, first: $first, reverse: $reverse) {
        edges { node {
          handle
          id
          updatedAt
          fields {
            ...MetaobjectFieldFields
            references(first: 100) {
              edges { node {
                ... on Metaobject {
                  id
                  fields {
                    key
                    value
                    type
                    references(first: 100) { edges { node { ...MetaobjectDetailFields } } }
                  }
                }
              } }
            }
            reference { ...MediaImageFields ...MetaobjectDetailFields }
          }
        } }
      }
    }
  `,
  khakis: `#graphql
    query MetaobjectImageKhakis($type: String!, $first: Int, $reverse: Boolean) {
      metaobjects(type: $type, first: $first, reverse: $reverse) {
        edges { node {
          handle
          id
          updatedAt
          fields {
            ...MetaobjectFieldFields
            references(first: 100) {
              edges { node {
                ... on Metaobject {
                  id
                  fields {
                    key
                    value
                    type
                    references(first: 100) { edges { node { ...MetaobjectDetailFields } } }
                  }
                }
              } }
            }
            reference { ...MediaImageFields ...MetaobjectDetailFields }
          }
        } }
      }
    }
  `,
  sunlove: `#graphql
    query MetaobjectImageSunlove($type: String!, $first: Int, $reverse: Boolean) {
      metaobjects(type: $type, first: $first, reverse: $reverse) {
        edges { node {
          handle
          id
          updatedAt
          fields {
            ...MetaobjectFieldFields
            references(first: 100) {
              edges { node {
                ... on Metaobject {
                  id
                  fields {
                    key
                    value
                    type
                    references(first: 100) { edges { node { ...MetaobjectDetailFields } } }
                  }
                }
              } }
            }
            reference { ...MediaImageFields ...MetaobjectDetailFields }
          }
        } }
      }
    }
  `,
  wellbeingexpress: `#graphql
    query MetaobjectImageWellbeingexpress($type: String!, $first: Int, $reverse: Boolean) {
      metaobjects(type: $type, first: $first, reverse: $reverse) {
        edges { node {
          handle
          id
          updatedAt
          fields {
            ...MetaobjectFieldFields
            references(first: 100) {
              edges { node {
                ... on Metaobject {
                  id
                  fields {
                    key
                    value
                    type
                    references(first: 100) { edges { node { ...MetaobjectDetailFields } } }
                  }
                }
              } }
            }
            reference { ...MediaImageFields ...MetaobjectDetailFieldsWellbeingexpress }
          }
        } }
      }
    }
  `,
  tenui: `#graphql
    query MetaobjectImageTenui($type: String!, $first: Int, $reverse: Boolean) {
      metaobjects(type: $type, first: $first, reverse: $reverse) {
        edges { node {
          handle
          id
          updatedAt
          fields {
            ...MetaobjectFieldFields
            references(first: 50) {
              edges { node {
                __typename
                ...MediaImageFields
                ... on Metaobject {
                  id
                  handle
                  type
                  fields {
                    key
                    value
                    type
                    reference { __typename ...MediaImageFields ...VideoFields }
                  }
                }
              } }
            }
            reference { __typename ...MediaImageFields ...VideoFields }
          }
        } }
      }
    }
  `,
};

export const metaobjectImageQuery = buildDocument(METAOBJECT_IMAGE_OPS[APP_NAME]);
